





















import { defineProps, withDefaults } from "@vue/runtime-dom";
interface Props {
  value: string | null;
  items: any;
  expanded?: boolean;
  selectedClass?: string;
  rounded?: boolean;
  buttonClass?: string;
  disabled?: any;
}
const __sfc_main = {};
__sfc_main.props = {
  value: {
    key: "value",
    required: true,
    type: [String, null]
  },
  items: {
    key: "items",
    required: true,
    type: null
  },
  expanded: {
    key: "expanded",
    required: false,
    type: Boolean,
    default: false
  },
  selectedClass: {
    key: "selectedClass",
    required: false,
    type: String,
    default: ""
  },
  rounded: {
    key: "rounded",
    required: false,
    type: Boolean,
    default: false
  },
  buttonClass: {
    key: "buttonClass",
    required: false,
    type: String,
    default: ""
  },
  disabled: {
    key: "disabled",
    required: false,
    type: null,
    default: () => false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {};
};
export default __sfc_main;
